import React from "react";

import Layout from "../../components/common/layout/layout";
import SEO from "../../components/common/layout/seo";
import Navigation from "../../components/common/navigation/navigation";
import TermsOfUse from "../../components/common/legal/TermsOfUse";

import Footer from "../../components/sections/footer";

import theme from "@studytools/core/ui/theme/muiTheme";
import { ThemeProvider } from "@material-ui/core";

const TermsPage: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <SEO title="Ako Maps" />
        <Navigation />
        <TermsOfUse />
        <Footer />
      </Layout>
    </ThemeProvider>
  );
};

export default TermsPage;
